import DiagramWithToggleKey from "../shared/DiagramWithToggleKey";
import CardiometabolicOmega3Combined from "./index";

const CardiometabolicOmega3WithToggleKey = props => (
  <DiagramWithToggleKey
    CombinedDiagram={CardiometabolicOmega3Combined}
    keyControlsId="cardiometabolic-omega3-key"
    {...props}
  />
);

export default CardiometabolicOmega3WithToggleKey;
